<template>
  <br>
  <div class="container-fluid">
  
  <br>
  <div class="container-fluid mt-2">

<div class="container-fluid pb-3 flex-grow-1 d-flex flex-column flex-row overflow-auto">
  <div class="row flex-grow-sm-1 flex-grow-0">
      <aside class="col-sm-3 flex-grow-sm-1 flex-shrink-1 flex-grow-0 sticky-top pb-sm-0 pb-3">
          <div class="bg-light border rounded-3 p-1 h-100 sticky-top">
              <ul class="nav nav-pills flex-sm-column flex-row mb-auto justify-content-between text-truncate">
                  <li class="nav-item">
                      <router-link to="./"><a href="#" class="nav-link px-2 text-truncate">
                          <i class="bi bi-house fs-5"></i>
                          <span class="d-none d-sm-inline">Home</span>
                      </a></router-link>
                  </li>
                  <li>
                    <router-link to="./Articles">
  <a href="" class="nav-link px-2 text-truncate">
                          <i class="bi bi-speedometer fs-5"></i>
                          <span class="d-none d-sm-inline">Articles</span>
                      </a></router-link>
                  </li>
                  <li>
                      <router-link to="./robotics"><a href="#" class="nav-link px-2 text-truncate"><i class="bi bi-robot fs-5"></i>
                          <span class="d-none d-sm-inline">Robots</span> </a></router-link>
                  </li>
                  <li>
                    <router-link to="./projects"><a href="#" class="nav-link px-2 text-truncate"><i class="bi bi-bricks fs-5"></i>
                          <span class="d-none d-sm-inline">Projects</span> </a></router-link>
                  </li>
                  <li>
                    <router-link to="./projects"><a href="#" class="nav-link px-2 text-truncate"><i class="bi bi-backpack2 fs-5"></i>
                          <span class="d-none d-sm-inline">Cartoons</span> </a></router-link>
                  </li>
                  <li>
                    <router-link to="./mobilegames"><a href="#" class="nav-link px-2 text-truncate"><i class="bi bi-controller fs-5"></i>
                          <span class="d-none d-sm-inline">Mobile Games</span> </a></router-link>
                  </li>
                  <li>
                    <router-link to="./volunteer"><a href="#" class="nav-link px-2 text-truncate"><i class="bi bi-people fs-5"></i>
                          <span class="d-none d-sm-inline">Volunteer Works</span> </a></router-link>
                  </li>
              </ul>
          </div>
      </aside>
      <main class="col overflow-auto h-100">
          <div class="bg-light border rounded-3 p-3">
            <div class="row">
                <div class="col-md-3 col-sm-6">
                  <router-link to="./robotics"><div class="card card-block">
                  <h4 class="card-title text-right"><i class="material-icons">Robotics</i></h4>
                <img src="../assets/robot1.jpg" alt="Photo of sunset">
                    <h5 class="card-title mt-3 mb-3">Robotics</h5>
                    <p class="card-text">My Engineering experience and works</p> 
              </div></router-link>
                </div>
                <div class="col-md-3 col-sm-6">
                  <router-link to="./programing"><div class="card card-block">
                  <h4 class="card-title text-right"><i class="material-icons">Programming</i></h4>
                <img src="../assets/program.jpg" alt="Photo of sunset">
                    <h5 class="card-title  mt-3 mb-3">Programming</h5>
                    <p class="card-text">My Websites, Apps, and Works.</p> 
              </div></router-link>
                </div>
                <div class="col-md-3 col-sm-6">
                 <router-link to="./songs"><div class="card card-block">
                  <h4 class="card-title text-right"><i class="material-icons">Songs</i></h4>
                <img src="../assets/Mr. Khusan.jpg" alt="Photo of sunset">
                    <h5 class="card-title  mt-3 mb-3">Songs</h5>
                    <p class="card-text">My Songs and Clips.</p> 
              </div></router-link>
                </div>
                <div class="col-md-3 col-sm-6">
                  <router-link to="./3dmodeling"><div class="card card-block">
                  <h4 class="card-title text-right"><i class="material-icons">3D Design and Modeling</i></h4>
                <img src="../assets/elephant.jpg" alt="Photo of sunset">
                    <h5 class="card-title  mt-3 mb-3">3D Design and Modeling</h5>
                    <p class="card-text">My Sprites and Objects in Blender 3D.</p> 
              </div></router-link>
                </div>    
                
</div>
          </div>
      </main>
  </div>
</div>
<div class="row">
 <div class="col-md-3 col-sm-6">
  <router-link to="./mobilegames"><div class="card card-block">
    <h4 class="card-title text-right"><i class="material-icons">Mobile Games</i></h4>
  <img src="../assets/Games.jpg" alt="Photo of sunset">
      <h5 class="card-title mt-3 mb-3">Mobile Games</h5>
      <p class="card-text">My Mobile Games Development and Production.</p> 
</div></router-link>
  </div>
  <div class="col-md-3 col-sm-6">
    <router-link to="./poesy"><div class="card card-block">
    <h4 class="card-title text-right"><i class="material-icons">Poesy</i></h4>
  <img src="../assets/book5.jpg" alt="Photo of sunset">
      <h5 class="card-title  mt-3 mb-3">Poesy</h5>
      <p class="card-text">My Papers and Inspires.</p> 
</div></router-link>
  </div>
  <div class="col-md-3 col-sm-6">
    <router-link to="./volunteer"><div class="card card-block">
    <h4 class="card-title text-right"><i class="material-icons">Volunteer work</i></h4>
  <img src="../assets/volunteer.jpg" alt="Photo of sunset">
      <h5 class="card-title  mt-3 mb-3">Volunteer work</h5>
      <p class="card-text">My Extracurricular and Volunteer work.</p> 
</div></router-link>
  </div>
  <div class="col-md-3 col-sm-6">
    <router-link to="./articles"><div class="card card-block">
    <h4 class="card-title text-right"><i class="material-icons">Articles</i></h4>
  <img src="../assets/book1.jpg" alt="Photo of sunset">
      <h5 class="card-title  mt-3 mb-3">Articles</h5>
      <p class="card-text">My excited Articles, Papers.</p> 
</div></router-link>
  </div>    
</div>
<br>
<hr>
<section class="hero-section">
<div class="container">
  <div class="row align-items-center border">
    <div class="col-md-6">
          <h1 class="hero-title">Web Sites</h1>
          <p class="hero-description">My work experiences in front-end and back-end.</p>
            <router-link to="./portfolio"><a href="#" class="btn btn-primary btn-lg">Get More</a></router-link>
        </div>
    <div class="col-lg-6">
      <img src="../assets/program.jpg" alt="Photo of sunset" class="blogImg img-fluid hero-image imageclass">
    </div>
  </div>
</div>
</section>
<br>

<section class="hero-section">
<div class="container">
  <div class="row align-items-center">
    
    <div class="col-lg-6">
      <img src="../assets/robot1w.jpg" alt="Photo of sunset" class="blogImg img-fluid hero-image imageclass">
    </div>
    <div class="col-md-6">
          <h1 class="hero-title">Robotics</h1>
          <p class="hero-description">My experiences and projects.</p>
          <router-link to="./robotics"><a href="#" class="btn btn-primary btn-lg">Get More</a></router-link>
        </div>
  </div>
</div>
</section>
<br>
<section class="hero-section">
    <div class="container">
      <div class="row align-items-center ">
        <div class="col-md-6">
          <h1 class="hero-title">My Poesy.</h1>
          <p class="hero-description">My books, poesy, dreams, experiences.</p>
          <router-link to="./poesy"><a href="#" class="btn btn-primary btn-lg">Get More</a></router-link>
        </div>
        <div class="col-lg-6">
          <img src="../assets/book3.jpg" alt="Photo of sunset" class="blogImg img-fluid hero-image imageclass">
        </div>
      </div>
    </div>
  </section>
<br>
<hr>
      <div class="container w-50 p-3 ">
        <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active" data-bs-interval="10000">
            <img src="../assets/robot1.jpg" class="d-block w-100 carouselImg" alt="...">
          </div>
          <div class="carousel-item" data-bs-interval="2000">
            <img src="../assets/program.jpg" class="d-block w-100 carouselImg" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../assets/Mr. Khusan.jpg" class="d-block w-100 carouselImg" alt="...">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
      </div>
        

     
  </div>
  <br>
 
</div>
<hr>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img{
  height:150px;
  width:100%;
}
.blogImg{
  height: 100%;
}
.carouselImg{
  height: 300px;
}
div [class^="col-"]{
  padding-left:5px;
  padding-right:5px;
}
.card{
  transition:0.5s;
  cursor:pointer;
}
.card-title{  
  font-size:15px;
  transition:1s;
  cursor:pointer;
}
.card-title i{  
  font-size:15px;
  transition:1s;
  cursor:pointer;
  color:#ffa710
}
.card-title i:hover{
  transform: scale(1.25) rotate(100deg); 
  color:#18d4ca;
  
}
.card:hover{
  transform: scale(1.05);
  box-shadow: 10px 10px 15px rgba(0,0,0,0.3);
}
.card-text{
  height:80px;  
}

.card::before, .card::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: scale3d(0, 0, 1);
  transition: transform .3s ease-out 0s;
  background: rgba(255, 255, 255, 0.1);
  content: '';
  pointer-events: none;
}
.card::before {
  transform-origin: left top;
}
.card::after {
  transform-origin: right bottom;
}
.card:hover::before, .card:hover::after, .card:focus::before, .card:focus::after {
  transform: scale3d(1, 1, 1);
}



.hero-section {
    background-color: #f8f9fa;
    padding: 5rem 0;
}

.hero-title {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
}

.hero-description {
    font-size: 1.2rem;
    margin-bottom: 2rem;
}

.hero-image {
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

@media (max-width: 767.98px) {
    .hero-title {
        font-size: 2.5rem;
    }

    .hero-description {
        font-size: 1rem;
    }

    .hero-image {
        margin: 2rem auto 0;
    }
}
</style>
